import React, { FC, useEffect } from 'react';
import { AnimatePresence, useCycle } from 'framer-motion';
import { MenuToggle } from './MenuToggle';
import { MenuMobileContent } from './MenuMobileContent';
import styled from 'styled-components';
import { IMenuItem } from '../Navigation/Navigation';
import { rem } from 'polished';

type Props = {
    open: boolean;
    itemIds: IMenuItem[];
};

export const MenuMobile: FC<Props> = ({ itemIds }) => {
    const [isOpen, toggleOpen] = useCycle(false, true);

    // useEffect(() => {
    //     if (isOpen) {
    //         const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    //         document.documentElement.style.setProperty('--scrollbar-compensation', `${scrollbarWidth}px`);
    //         document.body.style.overflowY = 'hidden';
    //         document.body.style.paddingRight = `${scrollbarWidth}px`;
    //     } else {
    //         document.documentElement.style.setProperty('--scrollbar-compensation', '0px');
    //         document.body.style.overflowY = '';
    //         document.body.style.paddingRight = '';
    //     }
    //     return () => {
    //         document.documentElement.style.setProperty('--scrollbar-compensation', '0px');
    //         document.body.style.overflowY = '';
    //         document.body.style.paddingRight = '';
    //     };
    // }, [isOpen]);

    return (
        <Wrapper>
            <MenuToggle toggle={() => toggleOpen()} isOpen={isOpen} />
            <AnimatePresence>
                {isOpen && <MenuMobileContent closeModal={() => toggleOpen()} elements={itemIds} />}
            </AnimatePresence>
        </Wrapper>
    );
};

const Wrapper = styled.div`
    @media (min-width: ${rem(1000)}) {
        display: none;
    }
`;
